import type { Page } from './page'
import { buildPage } from './page'
import type { TlsProductSummary } from './tls-product-summary'

export type TlsProductsPage = Page & {
  products: TlsProductSummary[]
}
const buildTlsProductsPage = (count: number, page: number, products: TlsProductSummary[]): TlsProductsPage => {
  const productsPage = ((buildPage(count, page): any): TlsProductsPage)
  productsPage.products = products
  return productsPage
}

export {
  buildTlsProductsPage
}



// WEBPACK FOOTER //
// ./src/types/tls-products-page.js